var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgProtect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.949219,
    width: 44.4138,
    height: 44.4138,
    rx: 7.4023,
    fill: "#212224"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.5266 24.7744C34.4305 27.0843 34.1207 28.5007 33.1218 29.4977C31.6739 30.9431 29.3435 30.9431 24.6825 30.9431H19.7388C15.0779 30.9431 12.7475 30.9431 11.2995 29.4977C9.85156 28.0523 9.85156 25.7258 9.85156 21.0731C9.85156 16.4204 9.85156 14.094 11.2995 12.6485C12.7475 11.2031 15.0779 11.2031 19.7388 11.2031H20.9553",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.1875 30.9453V35.8803",
    stroke: "white",
    strokeWidth: 1.85063
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.25 35.8789H27.12",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9531 27.2422H23.4206",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5269 15.5212V12.4369C32.0594 12.4369 30.2088 11.2031 30.2088 11.2031C30.2088 11.2031 28.3581 12.4369 25.8906 12.4369V15.5212C25.8906 19.8394 30.2088 21.0731 30.2088 21.0731C30.2088 21.0731 34.5269 19.8394 34.5269 15.5212Z",
    stroke: "white",
    strokeWidth: 1.85063,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProtect);
export default __webpack_public_path__ + "static/media/protect.5f8c269a2be7183b7db589c1c76f2e8e.svg";
export { ForwardRef as ReactComponent };